// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'face-happy';

export const Component = () => (
  <path
    fillRule='evenodd'
    d='M20.63 4.37C22.878 6.614 24 9.31 24 12.5c0 3.19-1.123 5.885-3.37 8.13C18.386 22.878 15.69 24 12.5 24c-3.19 0-5.885-1.123-8.13-3.37C2.122 18.386 1 15.69 1 12.5c0-3.19 1.123-5.885 3.37-8.13C6.614 2.122 9.31 1 12.5 1c3.19 0 5.885 1.123 8.13 3.37ZM10.48 2.033c2.111-.405 4.133-.224 6.11.629a10.945 10.945 0 0 1 4.76 3.907 10.656 10.656 0 0 1 1.753 5.93l-.011.363c-.122 2.765-1.153 5.156-3.134 7.094-2.066 2.066-4.536 3.1-7.456 3.1l-.379-.007c-2.01-.065-3.857-.65-5.506-1.79-1.797-1.213-3.1-2.786-3.908-4.762l-.144-.35c-.729-1.87-.863-3.817-.44-5.804.404-2.11 1.392-3.908 2.875-5.39l.272-.264a10.36 10.36 0 0 1 5.208-2.656ZM19 14H6v1.5s.877 4 6.467 4c5.589 0 6.533-4 6.533-4V14Zm-3-7a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1ZM9 7a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1Z'
  />
);

export const viewBox = '0 0 25 25';
